/*document.addEventListener("DOMContentLoaded", () => {
    const product = JSON.parse(JSON.stringify({ ...window.product }));
    
    const radioButtons = document.querySelectorAll('.product-options input[type="radio"]');
    const hiddenInput = document.querySelector("product-form product_id"); 
    const addToCartButton = document.querySelector(".add-to-cart");
  
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", (e) => {

        if(e.target.parentNode.querySelector('.product-children__options')){

        }

        const selectedOptions = {};
  
        document.querySelectorAll('input[type="radio"]:checked').forEach((checkedInput) => {
          const optionName = checkedInput.getAttribute("data-option");
          const optionValue = checkedInput.getAttribute("data-value");
          selectedOptions[optionName] = optionValue;
          console.log(selectedOptions)
        });
  
        
        const matchedVariant = product.variants.find((variant) =>
          variant.options.every((value, index) => value === selectedOptions[product.options[index]])
        );
  
        if (matchedVariant) {
          hiddenInput.value = matchedVariant.id;
  
          if (matchedVariant.available) {
            addToCartButton.disabled = false;
            addToCartButton.textContent = "Add to Cart";
          } else {
            addToCartButton.disabled = true;
            addToCartButton.textContent = "Sold Out";
          }
  
          
          const priceElement = document.querySelector(".product-price");
          if (priceElement) {
            priceElement.textContent = `$${(matchedVariant.price / 100).toFixed(2)}`;
          }
        } else {
          console.error("Не знайдено відповідного варіанту продукту");
        }
      });
    });
  });
  
*/


document.addEventListener("DOMContentLoaded", () => {
  const product = JSON.parse(JSON.stringify({ ...window.product }));
  const hiddenInput = document.getElementById("product_id");
  const addToCartButton = document.querySelector("product-form button.add-to-cart");

  function updateChildrenOptions(parentOption) {
    const parentElement = parentOption.parentNode;
    const childrenContainer = parentElement.querySelector('.product-children__options');

    if (!childrenContainer) return;

    const selectedParentValue = parentOption.getAttribute("data-value");
    const childOptions = childrenContainer.querySelectorAll("input[type='radio']");

    childOptions.forEach(option => {
      const optionValue = option.getAttribute("data-value");

      const isOptionAvailable = product.variants.some(variant => {
        return (
          variant.options.includes(selectedParentValue) &&
          variant.options.includes(optionValue)
        );
      });

      console.log(isOptionAvailable)

      if (isOptionAvailable) {
        option.parentNode.style.display = "";
      } else {
        option.parentNode.style.display = "none";
        option.checked = false;
      }
    });

    const firstAvailableOption = Array.from(childOptions).find(option => option.parentNode.style.display !== "none");
    if (firstAvailableOption) {
      firstAvailableOption.checked = true;
    }
  }

  function updateVariantId() {
    const selectedOptions = Array.from(document.querySelectorAll('.product-options input[type="radio"]:checked')).map(input => input.getAttribute("data-value"));

    const matchedVariant = product.variants.find(variant => {
      return selectedOptions.every(option => variant.options.includes(option));
    });

    if (matchedVariant) {
      hiddenInput.value = matchedVariant.id;

      if (matchedVariant.available) {
        addToCartButton.classList.remove('hidden');
        addToCartButton.classList.remove('disabled');
        addToCartButton.querySelector('.button__text').textContent = 'Add To Cart';
      } else {
        addToCartButton.classList.add('hidden');
        addToCartButton.classList.add('disabled');
        addToCartButton.querySelector('.button__text').textContent = 'Sold Out';
      }

      DisplayPrice(matchedVariant['price'] / 100, matchedVariant['compare_at_price'] / 100, 1);

      
    }
  }

  function initializeOptions() {
    const allRadioButtons = document.querySelectorAll('.product-options input[type="radio"]');

    allRadioButtons.forEach(radio => {
      radio.addEventListener("change", (event) => {
        const parentElement = event.target.parentNode;

        if (parentElement.querySelector('.product-children__options')) {
          updateChildrenOptions(event.target);
        }

        updateVariantId(); 
      });
    });

    const parentOptions = document.querySelectorAll('.product-options input[type="radio"][data-option]');
    parentOptions.forEach(option => {
      if (option.checked) {
        updateChildrenOptions(option);
      }
    });

    updateVariantId(); 
  }

  initializeOptions(); 
});
